<template>
    <calendar-structure v-if="buildCalendar" :key="calendarEvent"></calendar-structure>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component } from "vue-property-decorator";
    import TicketWidgetComponent from '../../TicketWidgetComponent';
    import CalendarStructure from '../calendar-structure/CalendarStructure.vue';

    @Component({
        components: {
            CalendarStructure
        }
    })

    export default class CalendarBase extends TicketWidgetComponent {
        buildCalendar: boolean = false;
        calendarEvent: any = null;

        mounted() {
            this.setUp();
        }

        setUp() {            
            // if we are routed here
            if(this.selectedEvent) {
                this.calendarEvent = this.selectedEvent._id;
                this.buildCalendar = true;
            }

            // if routing isn't enabled then listen for initialization
            this.$root.$on('eventSelected', (selectedEvent: any) => {
                this.calendarEvent = selectedEvent._id;
                this.buildCalendar = true;
            })
        }
    }
</script>